import { render, staticRenderFns } from "./HrSalaryCalcLeaveSocialDetail.vue?vue&type=template&id=1bfb2ef8&scoped=true&"
import script from "./HrSalaryCalcLeaveSocialDetail.vue?vue&type=script&lang=js&"
export * from "./HrSalaryCalcLeaveSocialDetail.vue?vue&type=script&lang=js&"
import style0 from "./HrSalaryCalcLeaveSocialDetail.vue?vue&type=style&index=0&id=1bfb2ef8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfb2ef8",
  null
  
)

export default component.exports